import React from 'react';
import { Link } from 'react-router-dom';
import properties from '../data/properties.json';
import PropertyFilterGrid from './PropertyFilterGrid';
import { propertyPath } from './PropertyCard';
import { SITE_URL, useSeo } from '../seo';

const PATH = '/propiedades';
const TITLE = 'Propiedades en Venta y Arriendo en Quito | J&K Realty';
const DESCRIPTION = `${properties.length} propiedades en venta y arriendo en Quito y Los Valles: casas, departamentos, terrenos y edificios. Agenda tu visita con J&K Realty.`;

const buildJsonLd = () => [
  {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: 'Propiedades en venta y arriendo en Quito y Los Valles',
    url: SITE_URL + PATH,
    description: DESCRIPTION,
    mainEntity: {
      '@type': 'ItemList',
      numberOfItems: properties.length,
      itemListElement: properties.map((p, index) => ({
        '@type': 'ListItem',
        position: index + 1,
        url: SITE_URL + propertyPath(p),
        name: p.seoTitle.replace(/\s*\|\s*J&K Realty$/, ''),
      })),
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Inicio', item: SITE_URL + '/' },
      { '@type': 'ListItem', position: 2, name: 'Propiedades', item: SITE_URL + PATH },
    ],
  },
];

const PropertiesIndex = () => {
  useSeo({ title: TITLE, description: DESCRIPTION, path: PATH, jsonLd: buildJsonLd() });

  return (
    <main className="property-page">
      <div className="container">
        <nav className="property-breadcrumbs properties-index-crumbs" aria-label="Migas de pan">
          <Link to="/">Inicio</Link>
          <span aria-hidden="true">›</span>
          <span aria-current="page">Propiedades</span>
        </nav>

        <header className="properties-index-header">
          <h1 className="properties-index-title">Propiedades en Venta y Arriendo en Quito y Los Valles</h1>
          <p className="properties-index-intro">
            {`Casas, departamentos, terrenos y edificios en Quito y Los Valles, con la asesoría de Karen Imbaquingo, agente inmobiliaria con más de 7 años de experiencia. Elige una propiedad para ver sus fotos, datos y precio, o escríbeme si buscas algo distinto.`}
          </p>
        </header>

        <PropertyFilterGrid priorityCount={2} />

        <div className="properties-cta">
          <a
            href="https://wa.me/593995410584"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            Consultar por WhatsApp
          </a>
          <p className="cta-subtext">¿No encuentras lo que buscas? Cuéntame qué necesitas.</p>
        </div>
      </div>
    </main>
  );
};

export default PropertiesIndex;
